import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=20d464b1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d464b1')) {
      api.createRecord('20d464b1', component.options)
    } else {
      api.reload('20d464b1', component.options)
    }
    module.hot.accept("./MainList.vue?vue&type=template&id=20d464b1&", function () {
      api.rerender('20d464b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainList.vue"
export default component.exports